export default __webpack_public_path__ + "static/media/vu.3ff7db7d.svg";